import { getDateFormat, getFullName } from '../../../../utils/common-methods';
import { toTrimmedString } from './shared';

export const resolveUserName = (user) => {
  if (!user) return null;
  if (typeof user === 'string') return toTrimmedString(user) || null;
  if (user?.name) return toTrimmedString(user.name) || null;
  if (user?.firstName || user?.lastName) {
    const fullName = getFullName(toTrimmedString(user.firstName), toTrimmedString(user.lastName));
    return toTrimmedString(fullName) || null;
  }
  return null;
};

export const resolvePostedBy = (data) =>
  toTrimmedString(data?.createdByName) ||
  toTrimmedString(data?.postedByName) ||
  resolveUserName(data?.createdByUser) ||
  resolveUserName(data?.approvedByUser) ||
  resolveUserName(data?.createdBy) ||
  resolveUserName(data?.postedBy) ||
  resolveUserName(data?.approvedBy) ||
  resolveUserName(data?.user) ||
  (data?.createdBy !== undefined && data?.createdBy !== null ? String(data.createdBy) : null) ||
  (data?.approvedBy !== undefined && data?.approvedBy !== null ? String(data.approvedBy) : null) ||
  null;

export const resolvePostedOn = (data) => {
  const rawDate = data?.postedOn || data?.approvedAt || data?.createdAt || data?.posted_at || data?.created_at || null;
  if (!rawDate) return null;
  return getDateFormat(rawDate) || rawDate;
};

export const resolvePostedWeek = (data) => {
  const startDate = data?.startDate || data?.start_date;
  const endDate = data?.endDate || data?.end_date;
  if (!startDate || !endDate) return null;
  const start = getDateFormat(startDate) || startDate;
  const end = getDateFormat(endDate) || endDate;
  return `${start} - ${end}`;
};

export const resolvePostingDate = (data) => {
  const rawDate = data?.postingDate || data?.posting_date || null;
  if (!rawDate) return null;
  return getDateFormat(rawDate) || rawDate;
};

export const resolveProductType = (data) => {
  const x3ProductType = toTrimmedString(
    data?.x3ProductName ||
      data?.x3_product_name ||
      data?.product?.x3_productname ||
      data?.productCategory?.x3_productname ||
      data?.productCategory?.x3ProductName,
  );
  if (x3ProductType) return x3ProductType.toUpperCase();

  return (
    toTrimmedString(data?.productType) ||
    toTrimmedString(data?.productTypeName) ||
    toTrimmedString(data?.product?.name) ||
    toTrimmedString(data?.productCategory?.name) ||
    null
  );
};

export const resolveCustomerName = (data) =>
  data?.locationName ||
  data?.customerName ||
  data?.location?.name ||
  data?.sublocation?.locationName ||
  data?.sublocation?.location?.name ||
  null;
